import * as React from "react";
import {
  Logo,
  TableOfContents,
  TableOfContentsItem,
} from "@stoplight/elements-core";
import { Flex, Heading } from "@stoplight/mosaic";
import { Link } from "react-router-dom";

type SidebarProps = {
  name: string;
  logo?: string;
  container: React.RefObject<HTMLElement>;
  pathname: string;
  tree: TableOfContentsItem[];
};

export const Sidebar: React.FC<SidebarProps> = ({
  name,
  logo,
  container,
  pathname,
  tree,
}) => {
  const handleTocClick = () => {
    if (container.current) {
      container.current.scrollIntoView();
    }
  };
  return (
    <>
      <Flex ml={4} mb={5} alignItems="center">
        {logo ? <Logo logo={{ url: logo, altText: "logo" }} /> : null}
        <Heading size={4}>{name}</Heading>
      </Flex>
      <Flex flexGrow flexShrink overflowY="auto" direction="col">
        <TableOfContents
          tree={tree}
          activeId={pathname}
          // @ts-ignore
          Link={Link}
          onLinkClick={handleTocClick}
        />
      </Flex>
    </>
  );
};
